@if (mode === 'renderer') {
  <!-- component in page viewer -->
}

@if (mode === 'editor') {
   <!-- component in page editor -->
}

@if (mode === 'preview') {
  <!-- component in thumbnail to add to page -->
}
